import React, { useCallback } from "react"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import * as Icons from "@nova/component-icons"
import {
    ConfirmationModalProps,
    useConfirmationModalContext,
} from "features/modals/WorkspaceConfirmationModalV2"
import { ConnectedAccountCreateAutelModal } from "./accounts/create/ConnectedAccountCreateAutelModal"
import { ConnectedAccountCreateSkydioModal } from "./accounts/create/ConnectedAccountCreateSkydioModal"
import { useAppSelector } from "integrations/redux/hooks"
import { selectWorkspaceRegion } from "features/data-management/workspace/WorkspaceManagementSlice"
import { ConnectedAccountCreateDjiModal } from "./accounts/create/ConnectedAccountCreateDjiModal"
import { SupportedRegions } from "@nova/constants"

export const ConnectedAccountSelectProviderModal = ({
    cancel,
    isPerformingAsyncConfirmCallback: _,
    isPerformingAsyncCancelCallback: __,
    confirm: ___,
    onCreateDji,
    onCreateAutel,
    onCreateSkydio,
}: ConfirmationModalProps & {
    onCreateDji: (email: string, password: string) => Promise<void>
    onCreateAutel: (email: string, password: string) => Promise<void>
    onCreateSkydio: (token: string) => Promise<void>
}) => {
    const confirmationModal = useConfirmationModalContext()
    const region = useAppSelector(selectWorkspaceRegion())

    const showDjiModal = useCallback(() => {
        void confirmationModal.confirm({
            RenderComponent: (props) => (
                <ConnectedAccountCreateDjiModal {...props} onCreate={onCreateDji} />
            ),
        })
    }, [confirmationModal, onCreateDji])

    const showAutelModal = useCallback(() => {
        void confirmationModal.confirm({
            RenderComponent: (props) => (
                <ConnectedAccountCreateAutelModal {...props} onCreate={onCreateAutel} />
            ),
        })
    }, [confirmationModal, onCreateAutel])

    const showSkydioModal = useCallback(() => {
        void confirmationModal.confirm({
            RenderComponent: (props) => (
                <ConnectedAccountCreateSkydioModal {...props} onCreate={onCreateSkydio} />
            ),
        })
    }, [confirmationModal, onCreateSkydio])

    return (
        <HighPriorityNovaModalContainer
            title="Select a Provider"
            closeModal={cancel}
            className="w-[28rem]"
        >
            <div className="flex flex-col gap-4 mt-4">
                {region !== SupportedRegions.USA && (
                    <Provider
                        name="DJI"
                        description="Sync flight logs from DJI Cloud."
                        onClick={showDjiModal}
                    />
                )}
                <Provider
                    name="Autel"
                    description="Sync flight logs from Autel Cloud."
                    onClick={showAutelModal}
                />
                <Provider
                    name="Skydio"
                    description="Sync flight logs from Skydio using an API token."
                    onClick={showSkydioModal}
                />
            </div>
        </HighPriorityNovaModalContainer>
    )
}

const Provider = ({
    name,
    description,
    onClick,
}: {
    name: string
    description: string
    onClick: () => void
}) => {
    return (
        <div
            className="border border-white-200 hover:border-gray-300 active:border-gray-500 cursor-pointer rounded-md px-4 py-5"
            onClick={onClick}
        >
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-gray-0">{name}</h3>
                    <h5 className="text-gray-200 mt-1">{description}</h5>
                </div>
                <Icons.Icon Icon={Icons.ArrowRight} className="text-gray-0" />
            </div>
        </div>
    )
}
